// extracted by mini-css-extract-plugin
export var Title = "Title-module--Title--1d266";